import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AuthService } from '../services/accounts/auth.service';
import { CustomHttpService } from '../services/custom-http.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertsService } from '../services/alerts.service';
import { CurrencyService } from '../services/currency.service';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.css']
})
export class UserProfileComponent implements OnInit {
  @ViewChild('editModal') editModal!: ElementRef;

  isEditModalOpen: boolean = false;
  isFetchingApprovalStages: boolean = false;
  isPhoneField: boolean = false;
  isPassField: boolean = false;
  isUpdatingUser: boolean = false;
  isDobField: boolean = false;
  isSalutationField: boolean = false;
  isGenderField: boolean = false;
  isNationalityField: boolean = false;
  isCurrencyField: boolean = false;
  user: any = {};
  userProfile: any = {};
  userForm!: FormGroup;
  errorMessage: string = ''

  currencies: string[] = [];

  salutations: any[] = ['Mr', 'Mrs', 'Ms']
  genders: any[] = ['Male', 'Female', 'Other']
  nationalities: any[] = [
    { code: "AF", name: "Afghanistan" },
    { code: "AL", name: "Albania" },
    { code: "DZ", name: "Algeria" },
    { code: "AS", name: "American Samoa" },
    { code: "AD", name: "Andorra" },
    { code: "AO", name: "Angola" },
    { code: "AI", name: "Anguilla" },
    { code: "AG", name: "Antigua and Barbuda" },
    { code: "AR", name: "Argentina" },
    { code: "AM", name: "Armenia" },
    { code: "AW", name: "Aruba" },
    { code: "AU", name: "Australia" },
    { code: "AT", name: "Austria" },
    { code: "AZ", name: "Azerbaijan" },
    { code: "BS", name: "Bahamas" },
    { code: "BH", name: "Bahrain" },
    { code: "BD", name: "Bangladesh" },
    { code: "BB", name: "Barbados" },
    { code: "BY", name: "Belarus" },
    { code: "BE", name: "Belgium" },
    { code: "BZ", name: "Belize" },
    { code: "BJ", name: "Benin" },
    { code: "BM", name: "Bermuda" },
    { code: "BT", name: "Bhutan" },
    { code: "BO", name: "Bolivia" },
    { code: "BA", name: "Bosnia and Herzegovina" },
    { code: "BW", name: "Botswana" },
    { code: "BR", name: "Brazil" },
    { code: "BN", name: "Brunei" },
    { code: "BG", name: "Bulgaria" },
    { code: "BF", name: "Burkina Faso" },
    { code: "BI", name: "Burundi" },
    { code: "KH", name: "Cambodia" },
    { code: "CM", name: "Cameroon" },
    { code: "CA", name: "Canada" },
    { code: "CV", name: "Cape Verde" },
    { code: "CF", name: "Central African Republic" },
    { code: "TD", name: "Chad" },
    { code: "CL", name: "Chile" },
    { code: "CN", name: "China" },
    { code: "CO", name: "Colombia" },
    { code: "KM", name: "Comoros" },
    { code: "CG", name: "Congo" },
    { code: "CD", name: "Congo (Democratic Republic)" },
    { code: "CR", name: "Costa Rica" },
    { code: "CI", name: "Côte d’Ivoire" },
    { code: "HR", name: "Croatia" },
    { code: "CU", name: "Cuba" },
    { code: "CY", name: "Cyprus" },
    { code: "CZ", name: "Czech Republic" },
    { code: "DK", name: "Denmark" },
    { code: "DJ", name: "Djibouti" },
    { code: "DM", name: "Dominica" },
    { code: "DO", name: "Dominican Republic" },
    { code: "EC", name: "Ecuador" },
    { code: "EG", name: "Egypt" },
    { code: "SV", name: "El Salvador" },
    { code: "GQ", name: "Equatorial Guinea" },
    { code: "ER", name: "Eritrea" },
    { code: "EE", name: "Estonia" },
    { code: "SZ", name: "Eswatini" },
    { code: "ET", name: "Ethiopia" },
    { code: "FJ", name: "Fiji" },
    { code: "FI", name: "Finland" },
    { code: "FR", name: "France" },
    { code: "GA", name: "Gabon" },
    { code: "GM", name: "Gambia" },
    { code: "GE", name: "Georgia" },
    { code: "DE", name: "Germany" },
    { code: "GH", name: "Ghana" },
    { code: "GR", name: "Greece" },
    { code: "GD", name: "Grenada" },
    { code: "GT", name: "Guatemala" },
    { code: "GN", name: "Guinea" },
    { code: "GW", name: "Guinea-Bissau" },
    { code: "GY", name: "Guyana" },
    { code: "HT", name: "Haiti" },
    { code: "HN", name: "Honduras" },
    { code: "HK", name: "Hong Kong" },
    { code: "HU", name: "Hungary" },
    { code: "IS", name: "Iceland" },
    { code: "IN", name: "India" },
    { code: "ID", name: "Indonesia" },
    { code: "IR", name: "Iran" },
    { code: "IQ", name: "Iraq" },
    { code: "IE", name: "Ireland" },
    { code: "IL", name: "Israel" },
    { code: "IT", name: "Italy" },
    { code: "JM", name: "Jamaica" },
    { code: "JP", name: "Japan" },
    { code: "JO", name: "Jordan" },
    { code: "KZ", name: "Kazakhstan" },
    { code: "KE", name: "Kenya" },
    { code: "KI", name: "Kiribati" },
    { code: "KR", name: "Korea (South)" },
    { code: "KW", name: "Kuwait" },
    { code: "KG", name: "Kyrgyzstan" },
    { code: "LA", name: "Laos" },
    { code: "LV", name: "Latvia" },
    { code: "LB", name: "Lebanon" },
    { code: "LS", name: "Lesotho" },
    { code: "LR", name: "Liberia" },
    { code: "LY", name: "Libya" },
    { code: "LI", name: "Liechtenstein" },
    { code: "LT", name: "Lithuania" },
    { code: "LU", name: "Luxembourg" },
    { code: "MG", name: "Madagascar" },
    { code: "MW", name: "Malawi" },
    { code: "MY", name: "Malaysia" },
    { code: "MV", name: "Maldives" },
    { code: "ML", name: "Mali" },
    { code: "MT", name: "Malta" },
    { code: "MH", name: "Marshall Islands" },
    { code: "MR", name: "Mauritania" },
    { code: "MU", name: "Mauritius" },
    { code: "MX", name: "Mexico" },
    { code: "FM", name: "Micronesia" },
    { code: "MD", name: "Moldova" },
    { code: "MC", name: "Monaco" },
    { code: "MN", name: "Mongolia" },
    { code: "ME", name: "Montenegro" },
    { code: "MA", name: "Morocco" },
    { code: "MZ", name: "Mozambique" },
    { code: "NA", name: "Namibia" },
    { code: "NR", name: "Nauru" },
    { code: "NP", name: "Nepal" },
    { code: "NL", name: "Netherlands" },
    { code: "NZ", name: "New Zealand" },
    { code: "NI", name: "Nicaragua" },
    { code: "NE", name: "Niger" },
    { code: "NG", name: "Nigeria" },
    { code: "NO", name: "Norway" },
    { code: "OM", name: "Oman" },
    { code: "PK", name: "Pakistan" },
    { code: "PW", name: "Palau" },
    { code: "PA", name: "Panama" },
    { code: "PG", name: "Papua New Guinea" },
    { code: "PY", name: "Paraguay" },
    { code: "PE", name: "Peru" },
    { code: "PH", name: "Philippines" },
    { code: "PL", name: "Poland" },
    { code: "PT", name: "Portugal" },
    { code: "QA", name: "Qatar" },
    { code: "RO", name: "Romania" },
    { code: "RU", name: "Russia" },
    { code: "RW", name: "Rwanda" },
    { code: "SA", name: "Saudi Arabia" },
    { code: "SN", name: "Senegal" },
    { code: "RS", name: "Serbia" },
    { code: "SC", name: "Seychelles" },
    { code: "SL", name: "Sierra Leone" },
    { code: "SG", name: "Singapore" },
    { code: "SK", name: "Slovakia" },
    { code: "SI", name: "Slovenia" },
    { code: "SB", name: "Solomon Islands" },
    { code: "SO", name: "Somalia" },
    { code: "ZA", name: "South Africa" },
    { code: "ES", name: "Spain" },
    { code: "LK", name: "Sri Lanka" },
    { code: "SD", name: "Sudan" },
    { code: "SR", name: "Suriname" },
    { code: "SE", name: "Sweden" },
    { code: "CH", name: "Switzerland" },
    { code: "SY", name: "Syria" },
    { code: "TW", name: "Taiwan" },
    { code: "TZ", name: "Tanzania" },
    { code: "TH", name: "Thailand" },
    { code: "TG", name: "Togo" },
    { code: "TO", name: "Tonga" },
    { code: "TT", name: "Trinidad and Tobago" },
    { code: "TN", name: "Tunisia" },
    { code: "TR", name: "Turkey" },
    { code: "TM", name: "Turkmenistan" },
    { code: "UG", name: "Uganda" },
    { code: "UA", name: "Ukraine" },
    { code: "AE", name: "United Arab Emirates" },
    { code: "GB", name: "United Kingdom" },
    { code: "US", name: "United States" },
    { code: "UY", name: "Uruguay" },
    { code: "UZ", name: "Uzbekistan" },
    { code: "VU", name: "Vanuatu" },
    { code: "VE", name: "Venezuela" },
    { code: "VN", name: "Vietnam" },
    { code: "YE", name: "Yemen" },
    { code: "ZM", name: "Zambia" },
    { code: "ZW", name: "Zimbabwe" }
  ];


  constructor(
    public auth: AuthService,
    private customHttpService: CustomHttpService,
    private fb: FormBuilder,
    public alertService: AlertsService,
    public currencyService: CurrencyService,
  ){}

  ngOnInit() {
    this.initForm()
    this.user = this.auth.user()
    console.log('user info', this.user)
    this.getUserInfo(this.user.user_id);
    this.currencyService.loadCurrencies().subscribe(() => {
      this.currencies = this.currencyService.currencies;
    });
    // this.editModal.nativeElement.style.display = 'none';
  }

    initForm() {
      this.userForm = this.fb.group({
        phone_number: ['', Validators.maxLength(30)],
        id_or_passport: ['', Validators.maxLength(50)],
        date_of_birth: ['', Validators.maxLength(30)],
        salutation: ['', Validators.maxLength(50)],
        gender: ['', Validators.maxLength(50)],
        nationality: ['', Validators.maxLength(50)],
        preferred_currency: ['', Validators.maxLength(10)]
      });
    }

  getUserInfo(userId: string) {
    this.isFetchingApprovalStages = true
    this.customHttpService.getUserById(userId).subscribe(
      (res) => {
        console.log('user profile', res)
        this.userProfile = res;
        this.isFetchingApprovalStages = false;
      },
      (error) => {
        console.error('Error fecthing user by id:', error);
        this.isFetchingApprovalStages = false;
      }
    )
  }

  updateUserProfile(){}

  openUpdateModal(updateField: string){
    // Reset the currency flag up front; each branch below sets the rest.
    this.isCurrencyField = false;
    if (updateField === 'phone') {
      this.isPhoneField = true;
      this.isPassField = false;
      this.isDobField = false;
      this.isSalutationField = false;
      this.isGenderField = false;
      this.isNationalityField = false;
      this.userForm.patchValue({
        phone_number: this.userProfile.phone_number
      });
    } else if (updateField === 'idPassport'){
      this.isPhoneField = false;
      this.isPassField = true;
      this.isDobField = false;
      this.isSalutationField = false;
      this.isGenderField = false;
      this.isNationalityField = false;
      this.userForm.patchValue({
        id_or_passport: this.userProfile.id_or_passport
      });
    } else if (updateField === 'dateOfBirth'){
      this.isPhoneField = false;
      this.isPassField = false;
      this.isDobField = true;
      this.isSalutationField = false;
      this.isGenderField = false;
      this.isNationalityField = false;
      this.userForm.patchValue({
        date_of_birth: this.userProfile.date_of_birth
      });
    } else if (updateField === 'salutation'){
      this.isPhoneField = false;
      this.isPassField = false;
      this.isDobField = false;
      this.isSalutationField = true;
      this.isGenderField = false;
      this.isNationalityField = false;
      this.userForm.patchValue({
        salutation: this.userProfile.salutation
      });
    } else if (updateField === 'nationality'){
      this.isPhoneField = false;
      this.isPassField = false;
      this.isDobField = false;
      this.isSalutationField = false;
      this.isGenderField = false;
      this.isNationalityField = true;
      this.userForm.patchValue({
        salutation: this.userProfile.nationality
      });
    } else if (updateField === 'currency'){
      this.isPhoneField = false;
      this.isPassField = false;
      this.isDobField = false;
      this.isSalutationField = false;
      this.isGenderField = false;
      this.isNationalityField = false;
      this.isCurrencyField = true;
      this.userForm.patchValue({
        preferred_currency: this.userProfile.preferred_currency || 'KES'
      });
    } else {
      this.isPhoneField = false;
      this.isPassField = false;
      this.isDobField = false;
      this.isSalutationField = false;
      this.isGenderField = true;
      this.isNationalityField = false;
      this.userForm.patchValue({
        gender: this.userProfile.gender
      });
    }
    this.editModal.nativeElement.style.display = 'flex';
  }

  closeUpdateModal(){
    this.editModal.nativeElement.style.display = 'none';
  }

  onSubmit(){
    console.log('user info', this.userForm.value);
    let reqBody = {};

    if (this.isPhoneField) {
      if (!this.userForm.value.phone_number){
        this.errorMessage = `This field cannot be blank. Enter your phone no.`
        setTimeout(() => {this.errorMessage = ''}, 4000);
        return;
      }
      reqBody = {
        phone_number: this.userForm.value.phone_number
      }
      this.updateUser(
        this.userProfile.id,
        reqBody
      )
    } else if (this.isPassField) {
      if (!this.userForm.value.id_or_passport) {
        this.errorMessage = `This field cannot be blank. Enter your id/passport no.`
        setTimeout(() => { this.errorMessage = ''}, 4000);
        return;
      }
      reqBody = {
        id_or_passport: this.userForm.value.id_or_passport
      }
      this.updateUser(
        this.userProfile.id,
        reqBody
      )
    } else if (this.isDobField) {
      const date = new Date(this.userForm.value.date_of_birth);
      const yyyyMMdd = date.toISOString().split('T')[0]; 
      if (!this.userForm.value.date_of_birth){
        this.errorMessage = `This field cannot be blank. enter date of birth.`
        setTimeout(() => {this.errorMessage = ''}, 4000);
        return;
      }
      reqBody = {
        date_of_birth: yyyyMMdd
      }
      this.updateUser(
        this.userProfile.id,
        reqBody
      )
    } else if (this.isSalutationField) {
      if (!this.userForm.value.salutation) {
        this.errorMessage = `This field cannot be blank. Enter your salutation.`
        setTimeout(() => { this.errorMessage = ''}, 4000);
        return;
      }

      reqBody = {
        salutation: this.userForm.value.salutation
      }

      this.updateUser(
        this.userProfile.id,
        reqBody
      )
    } else if (this.isGenderField) {
      if (!this.userForm.value.gender) {
        this.errorMessage = `This field cannot be blank. Enter your gender.`
        setTimeout(() => { this.errorMessage = ''}, 4000);
        return;
      }

      reqBody = {
        gender: this.userForm.value.gender === 'Male'
          ? 'M' 
          : this.userForm.value.gender === 'Female'
          ? 'F'
          : 'O'
      }
      
      this.updateUser(
        this.userProfile.id,
        reqBody
      )
    } else if (this.isNationalityField) {
      if (!this.userForm.value.nationality) {
        this.errorMessage = `This field cannot be blank. Enter your nationality.`
        setTimeout(() => { this.errorMessage = ''}, 4000);
        return;
      }

      reqBody = {
        nationality: this.userForm.value.nationality
      }

      this.updateUser(
        this.userProfile.id,
        reqBody
      )
    } else if (this.isCurrencyField) {
      if (!this.userForm.value.preferred_currency) {
        this.errorMessage = `This field cannot be blank. Select your currency.`
        setTimeout(() => { this.errorMessage = '' }, 4000);
        return;
      }

      reqBody = {
        preferred_currency: this.userForm.value.preferred_currency
      }

      this.updateUser(
        this.userProfile.id,
        reqBody
      )
    } else{

    }
  }

  

  // Update an existing user
  updateUser(userId: string, updateBody: any) {
    this.isUpdatingUser = true
    this.customHttpService.updateUser(userId, updateBody).subscribe(
      (response) => {
        this.isUpdatingUser = false
        console.log('profile updated', response)
        // Currency change takes effect app-wide immediately (header, etc.)
        if (updateBody?.preferred_currency) {
          this.currencyService.setCurrency(updateBody.preferred_currency);
        }
        this.getUserInfo(userId);  // Refresh the users list
        this.alertService.showSuccess("Profile updated successfully");
        this.closeUpdateModal();
      },
      (error) => {
        this.isUpdatingUser = false
        console.error('Error updating user:', error);
        this.alertService.showError('Error updating profile')
      }
    );
  }
}
